export default "__VITE_ASSET__CWKVABVa__"